import SideMenu from "./sideMenu";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useEffect, useState } from "react";
import { MdModeEditOutline } from "react-icons/md";
import { MdDelete } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import config from "../../config";
import { ThreeDots } from "react-loader-spinner";
import { v4 as uuidv4 } from "uuid";
import S3 from "react-aws-s3";
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "550px",
    maxHeight: "800px",
  },
};

export default function AddCategories(props) {
  const shopDetails = useSelector((state) => state.shopDetails);

  useEffect(() => {
    if (shopDetails.shopId) getExistingCategories();
  }, [shopDetails.shopId]);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState([]);
  const [categoryDetails, setCategoryDetails] = useState({});
  useEffect(() => {
    console.log("Category", categoryDetails);
  }, [categoryDetails]);
  const getExistingCategories = async () => {
    try {
      var response = await fetch(
        `${config.newApiGateway}/products/dashboard-products-categories`,
        {
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-Type": "application/json",
          },
          method: "post",
          body: JSON.stringify({
            action: "getCategoryList",
            shopId: shopDetails.shopId,
          }),
        },
      );
      var finalData = await response.json();
      console.log("Received Response", finalData);
      setCategory(finalData.categoryList);
      dispatch({
        type: "SET_SHOP_PROFILE_CATEGORY",
        payload: finalData.categoryList,
      });
      setLoading(false);
    } catch (err) {
      console.log("Error on fetching existing categories", err);
    }
  };

  return (
    <div>
      <div>
        <SideMenu on="items" />
      </div>
      <div className="reports-wrapper">
        <div>
          <h3 style={{ margin: "20px", color: "#EF4667" }}>
            <ArrowBackIcon
              style={{ fontSize: "2.5rem", cursor: "pointer" }}
              onClick={() => props.history.push("/dashboard/shop-items")}
            />
            Categories{" "}
          </h3>
        </div>
        <div style={{ background: "#ffff" }}>
          <div>
            <button>Add New Category</button>
          </div>
          <div className="newCategoryMainContainer">
            <div className="categoryListColumn">
              {Object.keys(category).map((data) => (
                <div onClick={() => setCategoryDetails(category[data])}>
                  {data}
                </div>
              ))}
            </div>
            <div className="SubCategoryDetails"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
const handleImageUpload = async (image) => {
  const id = uuidv4();
  const configSettings = {
    bucketName: "ghoshak-website-builder",
    region: "ap-south-1",
    accessKeyId: "",
    secretAccessKey: "",
  };
  var fileName = id + ".jpeg";
  var S3Client = new S3(configSettings);
  let data = await S3Client.uploadFile(image, fileName)
    .then((data) => {
      return data;
    })
    .catch((err) => {
      console.log("S3 Error", err);
    });
  console.log("IMAGE DATA", data);
  return data;
};
